import { render } from "./InputNumber.vue?vue&type=template&id=1372b356&scoped=true"
import script from "./InputNumber.vue?vue&type=script&lang=ts"
export * from "./InputNumber.vue?vue&type=script&lang=ts"

import "./InputNumber.vue?vue&type=style&index=0&id=1372b356&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1372b356"

export default script